import { useAppContext } from '../contexts/app-context'

const useTranslations = () => {
  const { appContext } = useAppContext()
  return appContext?.translations || {}
}

export default useTranslations
